import Axios from '@/Axios'


class WorkAllocationService {
    async createWorkAllocation(data) {
        let newdata = JSON.stringify(data)
        return await Axios.post('wms.wms.api.work_allocation.create_work_allocation', { data: newdata })
    }

    async getWorkAllocation(data) {
        console.log('data : ', data)

        return await Axios.get('wms.wms.api.work_allocation_tab.get_work_allocation_list_data', { params: { filters: JSON.stringify(data) } })
    }
    async getTabCount() {
        return await Axios.get('wms.wms.api.work_allocation_tab.get_tab_count')
    }

    async getChartStatus(search) {
        return await Axios.get('wms.wms.api.work_allocation_tab.get_chartstatus_options?search=' + search)
    }
    async updatePriority(priority, name) {
        return await Axios.post('wms.wms.api.work_allocation_tab.update_priority', {
            priority: priority,
            name: name,
        })
    }
    async updateChartLockIssue(chart_lock_issue, name) {
        return await Axios.post('wms.wms.api.work_allocation_tab.update_ChartLockIssue', {
            chart_lock_issue: chart_lock_issue,
            name: name,
        })
    }

    async assignChartCoder() {
        return await Axios.get('wms.wms.api.assign_chart.assign_chart_to_coder_user')
    }
}
export default new WorkAllocationService()
